export default __webpack_public_path__ + "0a7ecd5fc270c99ebd79d76c3297b21b.jpg";